/**
 * 
 * @author Jesus R. Nava Cruz
 * @company Erillam Healthcare
 * @version 1.0
 * 
 */

import ServicePath from "@/core/ServicePath";
import { MainRequest } from "@/core/request";

export default class CieRequest extends MainRequest{

    static addCie(data){
        return this.postSEC(ServicePath.CIE_ADD, data)
    }
    
    static listAllCie(){
        return this.getSEC(ServicePath.CIE_LIST_ALL)
    }

    static updateCie(data){
        return this.postSEC(ServicePath.CIE_UPDATE, data)
    }

    static deleteCie(data){
        return this.postSEC(ServicePath.CIE_DELETE, data)
    }

    static listCieByKey(data){
        return this.postSEC(ServicePath.CIE_LIST_BY_KEY, data)
    }

    static listCieByName(data){
        return this.postSEC(ServicePath.CIE_LIST_BY_NAME, data)
    }

}